import { useSessionStorageStore } from '@source/utilities/hooks/use-session-storage-store';
import createStore from '@utilities/store';

import { SESSION_STORAGE_NAME } from './utilities/constants';
import { UserProjectPhase, UserState } from './utilities/store.types';

const UPDATE_USER = 'init'; // 'init' is used by the useSessionStorage store to initialise store on load.
const CLEAR_USER = 'clearUser';
const UPDATE_WISHLIST = 'updateWishlist';
const ADD_PROJECTS = 'addProject';

const initialState = {
    loggedIn: false,
};

const actions = {
    [UPDATE_USER]: (state: UserState, newState: UserState) => {
        state.info = newState.info;
        state.wishlist = newState.wishlist;
        state.areas = newState.areas;
        state.projects = newState.projects;
        state.propertyTypes = newState.propertyTypes;
        state.loggedIn = newState.loggedIn;
        return state;
    },
    [CLEAR_USER]: (state: UserState) => {
        state.info = undefined;
        state.wishlist = undefined;
        state.areas = undefined;
        state.projects = undefined;
        state.propertyTypes = undefined;
        state.loggedIn = false;

        return state;
    },
    [UPDATE_WISHLIST]: (state: UserState, newWishlist: string[]) => {
        state.wishlist = [...newWishlist];

        return state;
    },
    [ADD_PROJECTS]: (state: UserState, newProjects: UserProjectPhase[]) => {
        if (state.projects) {
            state.projects = [...state.projects, ...newProjects];
        } else {
            state.projects = newProjects;
        }

        return state;
    },
};

// User store needs to be persistant in session.
export const userStore = useSessionStorageStore(
    SESSION_STORAGE_NAME,
    createStore<UserState>({
        initialState,
        actions,
    }),
);

export const updateUser = (newState: UserState) => {
    userStore.dispatch(UPDATE_USER, newState);
};

export const clearUser = () => {
    userStore.dispatch(CLEAR_USER);
};

export const updateWishlist = (newWishlist: string[]) => {
    userStore.dispatch(UPDATE_WISHLIST, newWishlist);
};
